import React, { useEffect, useRef, useState } from 'react';
import { CgSpinnerAlt } from 'react-icons/cg';
import cn from 'classnames';

interface IProps {
	url: string;
	id?: string;
}

const ScalingIframe: React.FC<IProps> = ({ url, id }) => {
	const [isLoading, setLoading] = useState<boolean>(true);
	const iframeRef = useRef<HTMLIFrameElement | null>(null);

	useEffect(() => {
		const handlePostMessage = (event: MessageEvent) => {
			if (event.data.type === 'adjustIframeHeight') {
				const height = event.data.height;
				if (iframeRef.current) {
					iframeRef.current.style.height = `${height}px`;
				}
			}
		};

		window.addEventListener('message', handlePostMessage);

		setTimeout(() => setLoading(false), 1000);

		return () => {
			window.removeEventListener('message', handlePostMessage);
		};
	}, []);

	if (isLoading) {
		return <CgSpinnerAlt className="animate-spin mx-auto w-16 h-16" />;
	}

	return (
		<div>
			<iframe
				ref={iframeRef}
				id="scalingIframe"
				src={url}
				className={cn('scaling-iframe', id)}
			/>
		</div>
	);
};

export default ScalingIframe;
